import { createSlice } from '@reduxjs/toolkit';

import { ErrorResponse } from 'types/api';
import { DictionaryState } from 'types/dictionaries';

import { RequestStatus } from 'constants/enums';

import { fetchDictionariesBatch, fetchDictionary } from './dictionariesThunks';

const initialState: DictionaryState = {
  data: {},
  status: RequestStatus.Idle,
  error: null
};

const dictionariesSlice = createSlice({
  name: 'dictionaries',
  initialState,
  reducers: {
    setDictionariesStatus: (state, action) => {
      state.status = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDictionary.fulfilled, (state, action) => {
        state.data[action.payload.dict] = action.payload.data;
      })
      .addCase(fetchDictionary.rejected, (state, action) => {
        state.error = action.payload as ErrorResponse;
      })
      .addCase(fetchDictionariesBatch.fulfilled, (state, action) => {
        action.payload.forEach((item: { dict: string; data: any }) => {
          state.data[item.dict] = item.data;
        });
      })
      .addCase(fetchDictionariesBatch.rejected, (state, action) => {
        state.error = action.payload as ErrorResponse;
      });
  }
});

export default dictionariesSlice.reducer;
export const { setDictionariesStatus } = dictionariesSlice.actions;
